import { Controller } from "@hotwired/stimulus"

// Modal that lazy-loads its body via a Turbo Frame. Each clickable row passes
// the show-action URL via `data-event-modal-url-param`; the controller resets
// the frame to a loading state, sets the new src (Turbo then fetches it), and
// opens the overlay.
export default class extends Controller {
  static targets = ["overlay", "frame"]

  connect() {
    this.keyDownHandler = this.handleKeyDown.bind(this)
    document.addEventListener("keydown", this.keyDownHandler)
    this.originalOverflow = document.body.style.overflow
    if (this.hasOverlayTarget) this.overlayTarget.classList.add("hidden")
  }

  disconnect() {
    document.removeEventListener("keydown", this.keyDownHandler)
    document.body.style.overflow = this.originalOverflow
  }

  open(event) {
    if (event) event.preventDefault()
    const url = event?.params?.url
    if (!url || !this.hasOverlayTarget || !this.hasFrameTarget) return

    this.frameTarget.innerHTML =
      '<div class="text-center py-10 text-gray-500"><i class="fas fa-spinner fa-spin mr-2"></i>Loading…</div>'
    this.frameTarget.removeAttribute("src")
    this.frameTarget.setAttribute("src", url)

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasOverlayTarget) return

    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    document.body.style.overflow = this.originalOverflow
  }

  handleContainerClick(event) {
    event.stopPropagation()
  }

  handleKeyDown(event) {
    if (event.key === "Escape" && this.isOpen()) this.close()
  }

  isOpen() {
    return this.hasOverlayTarget && !this.overlayTarget.classList.contains("hidden")
  }
}
